import React from 'react';
import {FormattedMessage} from "react-intl";

class PageNotFound extends React.Component {
    render() {
        return (
            <div className="error-container">
                <h2>
                    <FormattedMessage id="error.page_not_found" defaultMessage="Page not found" />
                </h2>
            </div>
        )
    }
}

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/containers/Error/PageNotFound.jsx